import React, { useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch, useLocation } from "react-router-dom";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes.js";
// import RequestRiderDocs from "views/docs/RequestRiderDocs";
// import ActiveRiderDocs from "views/docs/ActiveRiderDocs";
// import RiderProfile from "views/profile/RiderProfile";
import RefferedDetail from "views/RefferedDetail";
import Login from "views/admin_auth/Login";
import { Redirect } from "react-router";
import RefferedAmount from "views/RefferedAmount";
import TransferHistory from "views/TransferHistory";
import CreateArticle from "views/articles/CreateArticle";
import BlogDetailSection from "views/articles/BlogDetailSection";
import ArticleEdit from "views/articles/ArticleEdit";
import CreateTag from "views/tags/CreateTag";
import TagEdit from "views/tags/TagEdit";
import CreateMaker from "views/makes/CreateMaker";
import MakerEdit from "views/makes/MakerEdit";
import ModelsList from "views/makes_models/ModelsList";
import ModelEdit from "views/makes_models/ModelEdit";
import CreateModel from "views/makes_models/CreateModel";
import CreateFormInfo from "views/form_info/CreateFormInfo";
import FormInfoEdit from "views/form_info/FormInfoEdit";
import CreateSlider from "views/sliders/CreateSlider";
import SliderEdit from "views/sliders/SliderEdit";
import CreateSiteSetting from "views/site-setting/CreateSiteSetting";
import SiteSettingEdit from "views/site-setting/SiteSettingEdit";
import PermissionEdit from "views/permissions/PermissionEdit";
import CreatePermission from "views/permissions/CreatePermission";
import CreateAdmin from "views/admins/CreateAdmin";
import AdminEdit from "views/admins/AdminEdit";
import CreateCategory from "views/category/CreateCategory";
import CategoryEdit from "views/category/CategoryEdit";
import TrimList from "views/makes_models/TrimList";
import CreateFaq from "views/faqs/CreateFaq";
import FaqEdit from "views/faqs/FaqEdit";
import CreateTimeSlot from "views/timeslots/CreateTimeSlot";
import TimeSlotEdit from "views/timeslots/TimeSlotEdit";
import CreateGender from "views/gender/CreateGender";
import GenderEdit from "views/gender/GenderEdit";
import CategoryCreateFaq from "views/categoryFaqs/CategoryCreateFaq";
import CategoryFaqEdit from "views/categoryFaqs/CategoryFaqEdit";
import CreateCategories from "views/categories/CreateCategories";
import CategoriesEdit from "views/categories/CategoriesEdit";

var ps;

function Dashboard(props) {
  const [permit, setPermit] = useState([]);
  //my code
  const isAdmin = localStorage.getItem("njrujBf847hAfkxncmRbjfhy37AdyhbcKn84hdA8hggeras");


  const [backgroundColor, setBackgroundColor] = React.useState("black");
  const [activeColor, setActiveColor] = React.useState("info");
  const mainPanel = React.useRef();
  const location = useLocation();
  React.useEffect(() => {
    if (localStorage.getItem("permit")) {
      setPermit(JSON?.parse(localStorage.getItem("permit")));
    }

    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.body.classList.toggle("perfect-scrollbar-on");
      }
    };
  }, []);
  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);


  return (
    <div>
      {isAdmin ? (
        <>
          <Sidebar
            {...props}
            routes={routes}
            bgColor={backgroundColor}
            activeColor={activeColor}
          />
        </>
      ) : (
        <Redirect to="/admin/login-page" />
      )}
      <Route exact={true} path="/admin/login-page" component={Login} />

      <div className={isAdmin ? "main-panel" : ""} ref={mainPanel}>
        {isAdmin ? <DemoNavbar {...props} /> : ""}

        <Switch>
          {routes.map((prop, key) => {
            return (
              <Route
                path={prop.layout + prop.path}
                component={prop.component}
                key={key}
              />
            );
          })}
          {/* <Route
            exact={true}
            path="/admin/request-rider/docs/:id"
            component={RequestRiderDocs}
          /> */}
          {/* <Route
            exact={true}
            path="/admin/active-rider/docs/:id"
            component={ActiveRiderDocs}
          /> */}
          {/* <Route
            exact={true}
            path="/admin/rider/profile/:id"
            component={RiderProfile}
          /> */}
          <Route
            exact={true}
            path="/admin/referred-detail/:id"
            component={RefferedDetail}
          />

          <Route
            exact={true}
            path="/admin/referred-amount/:id"
            component={RefferedAmount}
          />

          <Route
            exact={true}
            path="/admin/transfer-history/:id"
            component={TransferHistory}
          />
          <Route
            exact={true}
            path="/admin/article/create"
            component={CreateArticle}
          />

          <Route
            exact={true}
            path="/admin/article/detail/:id"
            component={BlogDetailSection}
          />

          <Route
            exact={true}
            path="/admin/article/edit/:id"
            component={ArticleEdit}
          />

          <Route exact={true} path="/admin/tag/create" component={CreateTag} />

          <Route exact={true} path="/admin/tag/edit/:id" component={TagEdit} />

          <Route exact={true} path="/admin/faq/create" component={CreateFaq} />

          <Route exact={true} path="/admin/faq/edit/:id" component={FaqEdit} />

          <Route exact={true} path="/admin/categoryfaq/create" component={CategoryCreateFaq} />

          <Route exact={true} path="/admin/categoryfaq/edit/:id" component={CategoryFaqEdit} />

          <Route
            exact={true}
            path="/admin/maker/create"
            component={CreateMaker}
          />

          <Route
            exact={true}
            path="/admin/maker/edit/:id"
            component={MakerEdit}
          />
          <Route
            exact={true}
            path="/admin/maker/models/:id"
            component={ModelsList}
          />

          <Route
            exact={true}
            path="/admin/trim/model/:id"
            component={TrimList}
          />

          <Route
            exact={true}
            path="/admin/maker/model/create-model-:id-:name"
            component={CreateModel}
          />

          <Route
            exact={true}
            path="/admin/maker/models/edit/:id"
            component={ModelEdit}
          />

          <Route
            exact={true}
            path="/admin/form-infos/create"
            component={CreateFormInfo}
          />

          <Route
            exact={true}
            path="/admin/form-infos/edit/:id"
            component={FormInfoEdit}
          />
          <Route
            exact={true}
            path="/admin/slider/create"
            component={CreateSlider}
          />

          <Route
            exact={true}
            path="/admin/slider/edit/:id"
            component={SliderEdit}
          />

          {/* 
          <Route
            exact={true}
            path="/admin/referrel/create"
            component={CreateSlider}
          />

          <Route
            exact={true}
            path="/admin/slider/edit/:id"
            component={SliderEdit}
          /> */}


          <Route
            exact={true}
            path="/admin/site-settings/create"
            component={CreateSiteSetting}
          />

          <Route
            exact={true}
            path="/admin/site-settings/edit/:id"
            component={SiteSettingEdit}
          />

          <Route
            exact={true}
            path="/admin/permission/edit/:id"
            component={PermissionEdit}
          />
          <Route
            exact={true}
            path="/admin/permission/create"
            component={CreatePermission}
          />
          <Route
            exact={true}
            path="/admin/permission/edit/:id"
            component={PermissionEdit}
          />
          <Route
            exact={true}
            path="/admin/create/admin"
            component={CreateAdmin}
          />

          <Route
            exact={true}
            path="/admin/edit/admin/:id"
            component={AdminEdit}
          />

          <Route
            exact={true}
            path="/admin/category/create"
            component={CreateCategories}
          />
          <Route
            exact={true}
            path="/admin/category/edit/:id"
            component={CategoriesEdit}
          />

          <Route
            exact={true}
            path="/admin/gender/create"
            component={CreateGender}
          />
          <Route
            exact={true}
            path="/admin/gender/edit/:id"
            component={GenderEdit}
          />

          <Route
            exact={true}
            path="/admin/timeslot/create"
            component={CreateTimeSlot}
          />
          <Route
            exact={true}
            path="/admin/timeslot/edit/:id"
            component={TimeSlotEdit}
          />

        </Switch>
        {/* <Footer fluid /> */}
      </div>

      {/* <FixedPlugin
        bgColor={backgroundColor}
        activeColor={activeColor}
        handleActiveClick={handleActiveClick}
        handleBgClick={handleBgClick}
      /> */}
    </div>
  );
}

export default Dashboard;
